<template>
  <div class="vue-accordion" :class="{'is-open': open}">
    <div class="accordion-title">
      <button
          @click="open = ! open"
          @keydown.esc="open = false"
          :aria-expanded="open ? 'true' : 'false'"
          :aria-controls="bodyID"
          :id="headingID">
        <slot name="title"></slot>
        <i class="icon"></i>
      </button>
    </div>

    <div class="accordion-body" v-show-slide="open" :aria-labelledby="headingID" :id="bodyID">
      <div class="inner text-formatted">
        <slot name="body"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Accordion",

  props: ['initialOpen'],

  data() {
    return {
      open: false
    }
  },

  computed: {
    headingID() {
      return _.uniqueId('accordion-header-');
    },

    bodyID() {
      return _.uniqueId('accordion-body-');
    },

    isInitialOpen() {
      return _.isEqual(this.initialOpen, '1');
    }
  },

  created() {
    this.checkInitialOpen();
  },

  methods: {
    checkInitialOpen() {
      if (!this.isInitialOpen) {
        return;
      }

      this.open = true;
    }
  }
}
</script>